const doc = [({"da":({"js":({"admin":({"required_metadata":({"card":({"personal":"Personligt", "contact":"Kontakt", "required_metadata":"Påkrævede oplysninger"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;